var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center justify-center h-100"},[_c('div',{staticClass:"text-h1"},[_vm._v("404")]),_c('div',{staticClass:"text-h5"},[_vm._v("Page not found")])])
}]

export { render, staticRenderFns }